import { render, staticRenderFns } from "./CollateralInfoTab.vue?vue&type=template&id=3c7cc8bb&scoped=true&"
import script from "./CollateralInfoTab.vue?vue&type=script&lang=js&"
export * from "./CollateralInfoTab.vue?vue&type=script&lang=js&"
import style0 from "./CollateralInfoTab.vue?vue&type=style&index=0&id=3c7cc8bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7cc8bb",
  null
  
)

export default component.exports